'use strict';

/* Controllers */

app.controller('SelectUserController', ['$scope', '$rootScope', '$location', '$routeParams', '$timeout', 'User', 'Helper', 'Venue', 'Popup', 
    function ($scope, $rootScope, $location, $routeParams, $timeout, User, Helper, Venue, Popup) {

        // pass service to scope
        $scope.User = User;
        
    	// init vars
    	var pagination;
        var more_results_exist;

        // init scope vars
        $scope.getting_more_results = false;
        $scope.loading = false;
        $scope.users = [];


        /**
         * search users when user clicks on the search button
         */
        $scope.searchUsers = function(){
            // reset vars
    		$scope.getting_more_results = false;
            $scope.users = [];
            $scope.loading = true;


            // init pagination
            pagination = { limit: 20, offset: 0 };

            User.search($scope.search, pagination, function(resp, status){

                if( status == 200){
                    $timeout(function(){
                        $scope.users = resp.data.users;
                    }, 600);
                    
                    more_results_exist = resp.pagination.next;
                }
                else if( status != 500 ){
                    var resp_message = Helper.getProperty(resp, 'data.message');

                    if( resp_message == undefined ) Popup.error('Something went wrong :(');
                    else                            Popup.error(Helper.getProperty(resp, 'data.message'));
                }else{
                    Popup.error('Something went wrong :(');
                }

                // hide keyboard if on mobile
                $('body.touch input').blur();

                $scope.loading = false;
            });
    	}


    	/**
    	 * infinit scroll triggers this function
    	 * to get more search results
    	 */
    	$scope.getMoreResults = function(){
    		// prevent multiple calls
    		if($scope.getting_more_results || !more_results_exist) return;
    		$scope.getting_more_results = true;

    		// update pagination offset
    		pagination.offset = pagination.offset + pagination.limit;

    		// get more results
    		User.search($scope.search, pagination, function(resp, status){

    			if( status == 200){
                    
                    $timeout(function(){
    		    		$scope.users = $scope.users.concat( resp.data.users );
                    }, 600);

    				more_results_exist = resp.pagination.next;
    			}
    			else if( status != 500 ){
    				Popup.error(Helper.getProperty(resp, 'data.message'));
    			}else{
    				Popup.error('Something went wrong :(');
    			}

    			$scope.getting_more_results = false;
    		});
    	}


    	/**
    	 * select user from results
    	 * 
    	 * @param Object  user
    	 */
    	$scope.selectUser = function(user){

            // first save selected user
            $rootScope.globals.selectedUser = user;
                    
            // save selected user to browser local storage
            Helper.updateLocalStorageWithGlobalVariable();


            switch( $routeParams.next_page ){

                case 'drink':
                    if( User.isCheckedIn(user) ){
                        // get venue details
                        var venue_id = User.getCheckedInVenueId(user);

                        $scope.getVenueAndRedirect(venue_id);
                    }
                    else{
                        // user will select venue here
                        $location.path('/venues');
                    }
                    break;

                case 'send-money':
                    $location.path('/select-money-amount');
                    break;

                default:
            		$location.path('/');
                    break;
            }
    	}


        /**
         * function for getting data for venue and redirecting
         */
        $scope.getVenueAndRedirect = function(venue_id){

            Venue.getSingle(venue_id, function(resp, status){

                if( status == 200 ){
                    $rootScope.globals.selectedVenue = resp.data.venue;

                    // update local storage
                    Helper.updateLocalStorageWithGlobalVariable();

                    // skip select venue page and open menu
                    $location.path('/menu');
                }
                else{
                    Popup.error('Could not get venue from server.');
                }

            });
        }

    }]);